// GC Coach brand mark — sourced from for-engineering-auth/assets/glyph-mark.svg.
//
// Bracket-and-dots lockup. `currentColor` drives the brackets + left dot; the
// right dot is hardcoded to brand violet so the mark holds its identity on
// any surface (light or dark). Inherits color from the parent (set `color`
// to control the stroke + left-dot tone — e.g. `color: var(--bg)` on a dark
// brand panel).

import type { SVGProps } from 'react';

export function GlyphMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      role="img"
      aria-label="GC Coach mark"
      {...props}
    >
      <path d="M6 5 H4 V17 H6" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M16 5 H18 V17 H16" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <circle cx="9" cy="11" r="1.4" fill="currentColor" />
      <circle cx="13" cy="11" r="1.4" fill="#3F2BB8" />
    </svg>
  );
}
